import React, { useContext } from 'react';
import { modalBlurbs, shared } from '../../../../../constants/NationalAccount';
import { NationalAccountContext } from '../../../../../contexts';
import { ShowSpinner, ModalButtonGroup, ReturnError } from '../commons';
import { clickCta } from '../../../../../utils/analytics';

export const ConfirmEnrollModal = (): JSX.Element => {
  const {
    setValidResponseState,
    validResponseState,
    setShowModal,
    setErrorState,
    errorState,
    setIsLoading,
    isLoading,
    enrollAgreementCode,
  } = useContext(NationalAccountContext);

  const cancelValidation = () => {
    setErrorState(false);
    setShowModal(false);
    clickCta('pricing benefits: national account incentives overlay: cancel');
    setValidResponseState((prevState: any) => {
      return { ...prevState, enrollState: true };
    });
  };

  const handleEnrollAgreementCode = async () => {
    setIsLoading(true);
    setErrorState(false);
    const response = await enrollAgreementCode(
      true,
      validResponseState.agreementCodeEntered,
      '',
    );
    setIsLoading(false);
    if (!response || response?.hasError) {
      setErrorState(true);
    } else if (response.data) {
      setErrorState(false);
      setShowModal(false);
      clickCta(
        'pricing benefits: national account incentives: successful enrollment',
      );
      window.location.reload();
    }
  };

  return (
    <div className="sui-flex sui-flex-col" data-testid="ConfirmEnrollModal">
      <div className="sui-flex sui-flex-row sui-justify-start sui-align-center">
        <p className="sui-py-4 sui-text-base">
          {modalBlurbs.confirm.content.line1}
        </p>
        <div className="sui-px-4">{errorState && <ReturnError />}</div>
      </div>
      {isLoading && <ShowSpinner />}
      <ModalButtonGroup
        handleClose={cancelValidation}
        confirmBlurb={modalBlurbs.confirm.buttons.continue}
        cb={handleEnrollAgreementCode}
        cancelBlurb={shared.cancel}
      />
    </div>
  );
};
